import { Stack } from '@mui/material';
import { memo } from 'react';
import { ListElementWrapper } from '../../shared/ListElementWrapper';
import { getRecordTypeIdentifier } from '../../../pages/configuration-canvas/utils/getRecordTypeIdentifier';
import { CardContent } from './CardContent';
import {
  SelectedDependency,
  SelectedDependencyWithClearHistoryProps,
  DependenciesContentViewType,
} from '../../dependencies/types';
import { CardListItem as CardListItemType } from './CardsList';

interface CardListItemProps {
  item: CardListItemType;
  firstHistoryItem?: SelectedDependency;
  handleSetConfigurationItem: (props: SelectedDependencyWithClearHistoryProps) => void;
  withDetailedContentForRelatedObjects?: boolean;
  withApiNameOnHover?: boolean;
}

export const CardListItem = memo(
  ({
    item,
    firstHistoryItem,
    handleSetConfigurationItem,
    withDetailedContentForRelatedObjects: withDetailedContent,
    withApiNameOnHover,
  }: CardListItemProps) => {
    return (
      <Stack key={'wrapper_' + item.metadataId}>
        <ListElementWrapper
          elementId={getRecordTypeIdentifier(item.name, item.objectName)}
          sx={{
            minHeight: '64px',
            pr: 0,
            pl: 0,
            pt: 1.5,
            pb: 1.5,
          }}
          onWrapperClick={() => {
            handleSetConfigurationItem({
              id: item.id,
              dependencyType: item.dependencyType,
              parentType: item.parentType,
              name: item.name,
              objectName: item.objectName,
              clearHistory: true,
              contentType: DependenciesContentViewType.default,
            });
          }}
          isHighlighted={
            firstHistoryItem?.id
              ? firstHistoryItem?.id === item.id
              : firstHistoryItem?.name === item.name &&
                firstHistoryItem?.objectName === item.objectName
          }
          leftContent={
            <CardContent
              parentType={item.parentType}
              label={item.label}
              apiName={item.name}
              date={item.changedAt ?? ''}
              isActive={item.isActive}
              objectNames={item.referencedObjects}
              parentObject={item.objectName}
              dependencyType={item.dependencyType}
              withDetailedContentForRelatedObjects={withDetailedContent}
              withApiNameOnHover={withApiNameOnHover}
            />
          }
        />
      </Stack>
    );
  },
);

CardListItem.displayName = 'CardListItem';
